import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { IcecontrolSettings, IcepanelcontainerSettings, IcepanelSettings, PaymentMethods } from '../../../../icemedx-lib/src/components/models/icesettings';
import { assetjournal } from '../../../../icemedx-lib/src/models/accounting/assetjournal';
import { chargehistory } from '../../../../icemedx-lib/src/models/accounting/chargehistory';
import { expensejournal } from '../../../../icemedx-lib/src/models/accounting/expensejournal';
import { incomerevenuejournal } from '../../../../icemedx-lib/src/models/accounting/incomerevenuejournal';
import { medicalservice } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservice';
import { payment } from '../../../../icemedx-lib/src/models/accounting/payment';
import { servicepaymentreference } from '../../../../icemedx-lib/src/models/accounting/servicepaymentreference';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';
import { servicedate } from '../../../../icemedx-lib/src/models/ehr/subs/servicedate';
import { servicereference } from '../../../../icemedx-lib/src/models/ehr/subs/servicereference';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';
import { AppService } from '../app.service';

const serviceDesc = "Service Description";
const inventoryDesc = "Inventory Item Description";

@Component({
  selector: 'singleservicecharge',
  templateUrl: './singleservicecharge.component.html',
  styleUrls: ['./singleservicecharge.component.scss'],
  providers: [AppService]
})
export class SingleservicechargeComponent implements OnInit {

  @Input() trans_account: string = "";
  @Input() account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  @Input() service: medicalservice = null;
  @Input() caption: string = "Service Charge";
  @Input() listOfServices: any[] = [];
  @Input() listOfInventory: any[] = [];
  @Input() responsibleParties: any[] = [];
  @Input() currentCharges: medicalservice[] = [];
  @Input() currentHistory: chargehistory = new chargehistory(null);

  @Input() panelSync: IcepanelSettings = null;
  @Output() doneClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelClick: EventEmitter<any> = new EventEmitter<any>();
  acctHistoryNone: number = 0;
  acctHistoryJournal: number = 1;
  acctHistoryLedger: number = 2;
  acctHistoryClaims: number = 3;
  acctHistoryPayments: number = 4;
  isDescriptionInvalid: boolean = false;

  serviceChargeFormGrp: FormGroup = null;

  chargeType: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "ChargeType", "Type of Charge")
    .setControlName("ChargeType")
    .createFormControl(this.getChargeType(), [Validators.required]);

  chargeStatus: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "ChargeStatus", "Status of Item")
    .setControlName("ChargeStatus")
    .createFormControl(IceTypes.trans_status.isNone, [Validators.required])
    .setOptions(MessageService.getAccountItemStatues());

  fromDateCtrl: IcecontrolSettings = new IcecontrolSettings("icedatepicker", { placeholder: "From Date", width: "125px" }, null, null, "FromDate")
    .setControlName("FromDate")
    .createFormControl(Iceutility.GetLocalDate(), [Validators.required]);
  toDateCtrl: IcecontrolSettings = new IcecontrolSettings("icedatepicker", { placeholder: "To Date", width: "125px" }, null, null, "ToDate")
    .setControlName("ToDate")
    .createFormControl(Iceutility.GetLocalDate(), [Validators.required]);

  codeCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "Code", "Code")
    .setControlName("Code")
    .createFormControl("", [Validators.required]);

  serviceDescCtrl: IcecontrolSettings = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "100%" }, null, null, "ServiceDesc", serviceDesc)
    .setControlName("ServiceDesc")
    .createFormControl("", [Validators.required, Validators.minLength(1)]);

  copayDescCtrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "CoPayDesc", "Select Service")
    .setControlName("CoPayDesc")
    .createFormControl("", [Validators.required]);

  quantity: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%", inputType: "number" }, null, null, "Quantity", "Quantity")
  .setControlName("Quantity")
  .createFormControl(0.0, []);

  unitPrice: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "Price", "Price")
    .setControlName("Price")
    .createFormControl(0.0, [Validators.required, Validators.min(0.1)]);

  totalAmount: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "TotalAmount", "Total Amount")
    .setControlName("TotalAmount")
    .createFormControl(0.0, [Validators.required, Validators.min(0.1)])
    .setReadonly(true);

  amountDue: IcecontrolSettings = new IcecontrolSettings("icelabel", { width: "100%", color: "red" }, null, null, "AmountDue", "Amt. Due")
    .setControlName("AmountDue")
    .createFormControl(0.0, [])
    .setReadonly(true);

  amountPaid: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%", color: "red" }, null, null, "Paid", "Pay Amount")
    .setControlName("Paid")
    .createFormControl(0.0, []);

  types = [
    { value: IceTypes.coa_types.coaCoPayIncome, name: "Co-Pay" },
    { value: IceTypes.coa_types.coaServiceIncome, name: "Service" },
    { value: IceTypes.coa_types.coaOtherIncome, name: "Other Item" },
  ];

  applyChargeForService: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [{ name: "00703565301 - Toposar 20 MG/ML Injectable Solution", value: "" }], width: "100%" }, null, null, "ApplyChargeFor", "Apply Co-Pay For")
    .setControlName("ApplyChargeFor")
    .createFormControl(0, [Validators.required]);

  responsibleParty: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "ResponsibleParty", "Responsible Party")
    .setControlName("ResponsibleParty")
    .createFormControl(0, []);

  billingSummary: IcecontrolSettings = new IcecontrolSettings("icelabel", { width: "100%", height: "100px" }, null, null, "BillingSummary", "Responsible Party Summary")
    .setControlName("BillingSummary")
    .createFormControl("", []);

  notesCtrl: IcecontrolSettings = new IcecontrolSettings("icetextarea", { width: "100%", height: "200px" }, null, null, "Notes", "Notes")
    .setControlName("Notes")
    .createFormControl("", []);

  doneItemButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Done", glyphClass: "fa-plus-circle" }, null, null, "doneItem");
  cancelItemButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Cancel", glyphClass: "fa-plus-circle" }, null, null, "cancelItem");
  addNewItemButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Add Another Item", glyphClass: "fa-plus-circle" }, null, null, "addItem");

  constructor(private appSvc: AppService,
    private domainSvc: DomainService,
    private accSvc: AccountingService,
    private medCodeSvc: MedicalcodesService) {
  }

  initializeControls(): void {
    this.chargeType.getFormControl().setValue(this.getChargeType());
    this.chargeTypeChanged(this.getChargeType());
    this.responsibleParty.setOptions(this.responsibleParties);
    if (this.service == null) return;

    this.chargeStatus.getFormControl().setValue(Iceutility.toLong(this.service.trans_status));

    let dtFrom: any = null;
    let dtTo: any = null;

    if (this.service.SVCDTS != null && this.service.SVCDTS.length > 0) {
      dtFrom = Iceutility.isTextDateTime(this.service.SVCDTS[0].date_required) ? Iceutility.GetLocalDate(this.service.SVCDTS[0].date_required) : Iceutility.ConvertFromDotNetServerTime(this.service.SVCDTS[0].date_required);
      dtTo = Iceutility.isTextDateTime(this.service.SVCDTS[0].end_date_required) ? Iceutility.GetLocalDate(this.service.SVCDTS[0].end_date_required) : Iceutility.ConvertFromDotNetServerTime(this.service.SVCDTS[0].end_date_required);

      if (!Iceutility.isTextDateTime(this.service.SVCDTS[0].date_required)) {
        this.medCodeSvc.getCodes("DATETIME_CODE", "", [this.service.SVCDTS[0].date_required, this.service.SVCDTS[0].end_date_required].join(","), "").subscribe(
          data => {
            if (data && data.length > 0) {
              let bcFrom: basecode = data[0];
              this.fromDateCtrl.getFormControl().setValue(Iceutility.GetLocalDate(bcFrom.title));

              if (this.service.SVCDTS[0].date_required == this.service.SVCDTS[0].end_date_required) {
                this.toDateCtrl.getFormControl().setValue(Iceutility.GetLocalDate(bcFrom.title));
              }
            }
            if (data && data.length > 1) {
              let bcTo: basecode = data[1];
              this.toDateCtrl.getFormControl().setValue(Iceutility.GetLocalDate(bcTo.title));
            }
          },
          error => {
            console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
          });
      }
      else {
        this.fromDateCtrl.getFormControl().setValue(dtFrom);
        this.toDateCtrl.getFormControl().setValue(dtTo);
      }
    }


    this.codeCtrl.getFormControl().setValue(this.service.code);
    if (this.service.service_description.length > 0) {
      let svcDesc = [{ name: this.service.service_description, value: this.service.code }];
      this.serviceDescCtrl.getFormControl().setValue(JSON.stringify(svcDesc));
    }
    else {
      this.serviceDescCtrl.getFormControl().setValue("");
    }
    this.quantity.getFormControl().setValue(Iceutility.toDouble(this.service.quantity));
    this.unitPrice.getFormControl().setValue(Iceutility.toDouble(this.service.price));
    this.totalAmount.getFormControl().setValue(Iceutility.toDouble(this.service.total_amount).toFixed(2));
    let amtDue = Iceutility.toDouble(this.service.total_amount);
    let histSvc = this.currentHistory.getService(this.service.medical_service_key);
    if (histSvc != null) {
      let tempAmtDue = Iceutility.toDouble(this.currentHistory.getServiceAmountDue(this.service.medical_service_key));
      amtDue = tempAmtDue;
      this.amountDue.getFormControl().setValue(tempAmtDue);
    }
    else {
      this.amountDue.getFormControl().setValue(amtDue);
    }
    this.amountDue.properties.color = amtDue > 0 ? "red" : "green";
    this.notesCtrl.getFormControl().setValue(this.service.additional_note);

    this.copayDescCtrl.getFormControl().setValue(this.service.copay_service_key + "|" + this.service.code);
    this.responsibleParty.getFormControl().setValue(AccountingService.getPartyBucketKey(this.service));
    setTimeout(() => {
      this.serviceDescCtrl.setMultipleSelection(false);
    });

    if (!this.showAddNewItem()) {
      this.chargeType.setDisabled(true);
    }
    this.setControlEditing(amtDue == Iceutility.toDouble(this.service.total_amount));
  }

  reSubscribeToInitialize(): void {
    if (this.panelSync != null
      && (this.panelSync.initializeEvent == null
        || this.panelSync.initializeEvent.observers.length == 0)) {
      this.panelSync.createInitializeEvent().subscribe(
        event => {
          this.initializeControls();
        },
        error => {
        }
      );
    }
  }

  ngOnInit() {
    if (this.panelSync != null) {
      this.panelSync.createInitializeEvent().subscribe(
        event => {
          this.initializeControls();
        },
        error => {
        }
      );
    }
    this.chargeType.setOptions(this.types);
    this.chargeStatus.setOptions(MessageService.getAccountItemStatues());
    this.chargeTypeChanged(this.getChargeType());
    this.responsibleParty.setOptions(this.responsibleParties);
  }

  getChargeType(): IceTypes.coa_types {
    if (this.service == null) return IceTypes.coa_types.coaServiceIncome;

    return Iceutility.toLong(this.service.inc_coa_type);
  }

  isCoPay(): boolean {
    return this.service.inc_coa_type == IceTypes.coa_types.coaCoPayIncome;
  }

  isReadyOnly(): boolean {
    return Iceutility.toLong(this.service.trans_status) != IceTypes.trans_status.isNone;
  }

  resetCalculations() {
    this.quantity.getFormControl().setValue(0.0);
    this.unitPrice.getFormControl().setValue(0.0);
    this.totalAmount.getFormControl().setValue(0.0);
  }

  resetTypeDescriptions(resetCode: boolean) {
    this.serviceDescCtrl.getFormControl().setValue("");
    this.copayDescCtrl.getFormControl().setValue("");

    if (resetCode) this.codeCtrl.getFormControl().setValue("");
  }

  setControlEditing(allowPriceChange: boolean): void {
    let readonly = this.isReadyOnly();
    this.fromDateCtrl.setReadonly(readonly);
    this.toDateCtrl.setReadonly(readonly);
    this.responsibleParty.setDisabled(readonly);
    this.codeCtrl.setReadonly(readonly);

    if (allowPriceChange) {
      this.quantity.setReadonly(readonly);
      this.unitPrice.setReadonly(readonly);
    }
    else {
      this.quantity.setReadonly(true); // don't allow if payments or adjustment are made
      this.unitPrice.setReadonly(true);
    }
    this.totalAmount.setReadonly(true); // always RO
    this.amountDue.setReadonly(true); // always RO
    this.notesCtrl.setReadonly(readonly);
    this.copayDescCtrl.setReadonly(readonly);
    this.serviceDescCtrl.setReadonly(readonly);
  }

  showHistory(): boolean {
    if (this.service == null || this.service.medical_service_key.length == 0) return false;
    return this.service.medical_service_key.length > 0;
  }
  showAddNewItem(): boolean {
    return this.service.medical_service_key.length == 0;
  }

  /////////////////////////////////////////////
  // Events
  typeSelectChange(event): void {
    this.service.inc_coa_type = <IceTypes.coa_types>event.value;
    this.chargeTypeChanged(this.getChargeType());
  }

  statusSelectChange(event): void {
    this.service.trans_status = event.value;
    let amtDue = this.amountDue.getFormControl().value;
    this.setControlEditing(amtDue == Iceutility.toDouble(this.service.total_amount));
  }

  serviceDescChange(event): void {
    if (event.autocompleteRemoveSettings != null) {
      this.resetCalculations();
    }

    let svcDescCtrl: IcecontrolSettings = <IcecontrolSettings>event.autocompleteSettings;
    let selected = null;
    try {
      selected = JSON.parse(svcDescCtrl.getFormControl().value);
      if (selected != null && selected.length > 0)
        selected = selected[0]
      else
        throw "Unable to parse service selected";
    }
    catch (e) {
      console.log(e);
      return;
    }

    let chrgeType = this.getChargeType();
    let thisList = null;
    if (chrgeType == IceTypes.coa_types.coaServiceIncome) {
      thisList = this.listOfServices;
    }
    else if (chrgeType == IceTypes.coa_types.coaOtherIncome) {
      thisList = this.listOfInventory;
    }
    else {
      return;
    }

    let svcs = thisList.filter(s => s.code == selected.value);
    if (svcs.length > 0) {
      let qty = 1.0;
      this.quantity.getFormControl().setValue(qty);
      let price = Iceutility.toDouble(svcs[0].price);
      this.unitPrice.getFormControl().setValue(price);
      let total = price * qty;
      this.totalAmount.getFormControl().setValue(total.toFixed(2));

      this.codeCtrl.getFormControl().setValue(svcs[0].code);
    }
  }

  serviceDescChanged(event) {
    if (event.currentTarget == null) return;

    let name = event.currentTarget.value;
    // do not add empty string as an option in the autocomplete
    if (Iceutility.isStringUndefinedNullOrEmpty(name)) {
      return;
    }

    let storedCode = this.codeCtrl.getFormControl().value;
    let code = storedCode == "" ? Iceutility.guid(true).substring(0, 7) : storedCode;

    const ct = this.getChargeType();
    if (IceTypes.coa_types.coaServiceIncome == ct) {
      this.listOfServices.push({ name: name, value: code, code: code, price: 0.0, key: "" });
      this.serviceDescCtrl.getFormControl().setValue(this.listOfServices[this.listOfServices.length - 1]);
    }
    else if (IceTypes.coa_types.coaOtherIncome == ct) {
      this.listOfInventory.push({ name: name, value: code, code: code, price: 0.0, key: "" });
      this.serviceDescCtrl.getFormControl().setValue(this.listOfInventory[this.listOfInventory.length - 1]);
    }

    this.isDescriptionInvalid = false;

    if (storedCode == "")
      this.codeCtrl.getFormControl().setValue(code);
  }

  copayDescChange(event): void {
    let copaySvcKey = event.value;
    let optFound = this.copayDescCtrl.getOptions().filter(o => o.value == copaySvcKey);
    if (optFound.length > 0) {
      let parts = optFound[0].value.split("|");
      this.codeCtrl.getFormControl().setValue(parts[1]);
    }
  }

  chargeTypeChanged(ct: IceTypes.coa_types): void {
    switch (ct) {
      case IceTypes.coa_types.coaServiceIncome:
      case IceTypes.coa_types.coaOtherIncome: {
        this.serviceDescCtrl.setOptions(IceTypes.coa_types.coaServiceIncome == ct ? this.listOfServices : this.listOfInventory);
        this.serviceDescCtrl.placeholder = serviceDesc;
        break;
      }
      case IceTypes.coa_types.coaCoPayIncome: { 
        if (this.currentCharges != null && this.copayDescCtrl.getOptions().length == 0) {
          let opts = [];
          for (let ichrg = 0; ichrg < this.currentCharges.length; ichrg++) {
            let chrg = this.currentCharges[ichrg];
            // Don't show copays
            if (Iceutility.toLong(chrg.inc_coa_type) == IceTypes.coa_types.coaCoPayIncome)
              continue;

            let dtFrom = Iceutility.isTextDateTime(chrg.SVCDTS[0].date_required) ? Iceutility.getDateTextEx(chrg.SVCDTS[0].date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(chrg.SVCDTS[0].date_required), null, false);
            let dtTo = Iceutility.isTextDateTime(chrg.SVCDTS[0].end_date_required) ? Iceutility.getDateTextEx(chrg.SVCDTS[0].end_date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(chrg.SVCDTS[0].end_date_required), null, false);
            let desc = chrg.service_description;
            if (dtFrom != null && dtFrom.length > 0)
              desc += " From: " + dtFrom;

            if (dtTo != null && dtTo.length > 0)
              desc += " To: " + dtTo;

            opts.push({ name: desc, value: chrg.medical_service_key + "|" + chrg.code });
          }
          this.copayDescCtrl.setOptions(opts);
        }
        break;
      }
      default: {
        this.serviceDescCtrl.setOptions(this.listOfInventory);
        this.serviceDescCtrl.placeholder = inventoryDesc;
        break;
      }
    }

    this.resetTypeDescriptions(true);
    this.resetCalculations();
  }

  codeChange(event, chrgeType: IceTypes.coa_types, codeCtrl: IcecontrolSettings) {
    let thisList = null;
    if (chrgeType == IceTypes.coa_types.coaServiceIncome) {
      thisList = this.listOfServices;
    }
    else if (chrgeType == IceTypes.coa_types.coaOtherIncome) {
      thisList = this.listOfInventory;
    }
    else {
      this.resetTypeDescriptions(false);
      this.resetCalculations();
      return;
    }

    let svcs = thisList.filter(s => s.code == codeCtrl.getFormControl().value);
    if (svcs.length > 0) {
      let selected = [{ name: svcs[0].name, value: svcs[0].code }];

      this.serviceDescCtrl.getFormControl().setValue(JSON.stringify(selected));
      let qty = 1.0;
      this.quantity.getFormControl().setValue(qty);
      let price = Iceutility.toDouble(svcs[0].price);
      this.unitPrice.getFormControl().setValue(price);
      let total = price * qty;
      this.totalAmount.getFormControl().setValue(total.toFixed(2));
    }
    else {
      this.resetTypeDescriptions(false);
      this.resetCalculations();
    }
  }

  codeEntered(event) {
    if (event.keydownEnterSettings == null) return;

    let codeCtrl: IcecontrolSettings = <IcecontrolSettings>event.keydownEnterSettings;
    this.codeChange(event, this.getChargeType(), codeCtrl);
  }

  codeTab(event) {
    if (event.keydownTabSettings == null) return;

    let codeCtrl: IcecontrolSettings = <IcecontrolSettings>event.keydownTabSettings;
    this.codeChange(event, this.getChargeType(), codeCtrl);
  }

  quantityKeyUp(event) {
    let newQty = Iceutility.toDouble(this.quantity.getFormControl().value);
    let price = Iceutility.toDouble(this.unitPrice.getFormControl().value);
    let total = (price * newQty).toFixed(2);
    this.totalAmount.getFormControl().setValue(total);
    this.quantity.getFormControl().setValue(newQty);
    this.amountDue.getFormControl().setValue(total);
  }

  priceKeyUp(event) {
    let qty = Iceutility.toDouble(this.quantity.getFormControl().value);
    let newPrice = Iceutility.toDouble(this.unitPrice.getFormControl().value);
    let total = (newPrice * qty).toFixed(2);
    this.totalAmount.getFormControl().setValue(total);
    if (event.key == ".") return;
    this.unitPrice.getFormControl().setValue(newPrice);
    this.amountDue.getFormControl().setValue(total);
  }

  quantityChanged(event) {
    let newQty = Iceutility.toDouble(event.currentTarget.value);
    let price = Iceutility.toDouble(this.unitPrice.getFormControl().value);
    let total = (price * newQty).toFixed(2);
    this.totalAmount.getFormControl().setValue(total);
    this.amountDue.getFormControl().setValue(total);
  }

  amountPaidKeyUp(event) {
    let amtPaid = Iceutility.toDouble(this.amountPaid.getFormControl().value);
    this.amountPaid.getFormControl().setValue(amtPaid);
  }

  responsiblePartySelectChange(event): void {
    let thisPartyBucketKey = event.value;
    let optFound = this.responsibleParty.getOptions().filter(o => o.value == thisPartyBucketKey);

    this.billingSummary.getFormControl().setValue("");
    if (optFound.length > 0) {
      this.billingSummary.getFormControl().setValue(optFound[0].summary.join("<br>"));
    }
  }

  addNewItemClick(event): void {
    event.addContinue = true;
    this.doneItemClick(event);
  }

  cancelItemClick(event): void {
    this.cancelClick.emit();
    this.service = null;
    this.reSubscribeToInitialize();
  }

  doneItemClick(event): any {
    let type = this.chargeType.getFormControl().value;
    let status = this.chargeStatus.getFormControl().value;
    let fromDt = this.fromDateCtrl.getFormControl().value;
    let toDt = this.toDateCtrl.getFormControl().value;
    let code = this.codeCtrl.getFormControl().value;
    let svcDesc = this.serviceDescCtrl.getFormControl().value;
    let copaySvcKey = this.copayDescCtrl.getFormControl().value;
    let qty = this.quantity.getFormControl().value;
    let price = this.unitPrice.getFormControl().value;
    let total = this.totalAmount.getFormControl().value;
    let paid = this.amountPaid.getFormControl().value;
    let ntes = this.notesCtrl.getFormControl().value;
    // To do validation

    if (this.serviceDescCtrl.getFormControl().invalid) {
      this.serviceDescCtrl.getFormControl().markAsTouched();
      this.isDescriptionInvalid = true;
      return false;
    } else {
      this.isDescriptionInvalid = false;
    }

    if (this.unitPrice.getFormControl().invalid) {
      this.unitPrice.getFormControl().markAsTouched();
      return false;
    }
    if (this.codeCtrl.getFormControl().invalid) {
      this.codeCtrl.getFormControl().markAsTouched();
      return false;
    }
    if (this.totalAmount.getFormControl().invalid) {
      this.totalAmount.getFormControl().markAsTouched();
      return false;
    }

    this.service.inc_coa_type = <IceTypes.coa_types>type;
    this.service.trans_status = <IceTypes.trans_status>status;
    if (this.service.inc_coa_type == IceTypes.coa_types.coaServiceIncome
      || this.service.inc_coa_type == IceTypes.coa_types.coaOtherIncome) {
      let obj = null;
      try {
        obj = JSON.parse(svcDesc);
        if (obj != null && obj.length > 0) {
          this.service.service_description = obj[0].name;
          this.service.code = obj[0].value;
          if (this.service.inc_coa_type == IceTypes.coa_types.coaOtherIncome) {
            let invFound = this.serviceDescCtrl.getOptions().filter(o => o.value == obj[0].value);
            if (invFound.length > 0) {
              this.service.other_items_key = invFound[0].key;
            }
          }
        }
      }
      catch (e) {
        console.log(e);
        let svcDescElem: HTMLInputElement = <HTMLInputElement>document.getElementById(this.serviceDescCtrl.id);
        this.service.service_description = svcDescElem.value;
        this.service.code = code;
      }
    }
    else {
      let optFound = this.copayDescCtrl.getOptions().filter(o => o.value == copaySvcKey);
      if (optFound.length > 0) {
        this.service.service_description = optFound[0].name;
        let parts = optFound[0].value.split("|");
        this.service.copay_service_key = parts[0];
        this.service.code = parts[1];
      }
    }
    this.service.quantity = qty
    this.service.price = price;
    this.service.total_amount = total;
    this.service.additional_note = ntes;
    AccountingService.setServiceSubscriberFromDDLKey(this.responsibleParty, this.service);
    let svcdts = null;
    let foundDt = this.service.SVCDTS.filter(sdt => sdt.datetime_qualifier == "472");
    if (foundDt.length == 0) {
      svcdts = new servicedate();
      this.service.SVCDTS.push(svcdts);
    }
    else {
      svcdts = foundDt[0];
    }
    svcdts.date_required = Iceutility.convertToUTCEx(fromDt);
    svcdts.end_date_required = Iceutility.convertToUTCEx(toDt);

    event.paid = paid;

    this.doneClick.emit(event);
    this.service = null;
  }
}
